import { createModule } from "saga-slice";
import { call, put } from "redux-saga/effects";
import productService from "../services/productService";
const initialState = {
    products: [],
    unites: [],
    loading: false,
    error: null,
    totalElements: 0, // Total number of records
    totalPages: 0, // Total number of pages
    pageNumber: 0, // Current page number
    pageSize: 20, // Size of each page
    prices: [],
};

const productSlice = createModule({
    name: 'products',
    initialState,
    reducers: {
        updatePrice: (state) => {
            state.loading = true;
        },
        findPrixAchat: (state) => {
            state.loading = true;
        },
        findAllPrices: (state) => {
            state.loading = true;
        },
        search: (state) => {
            state.loading = true;
        },
        findAll: (state) => {
            state.loading = true;
        },
        findReception: (state) => {
            state.loading = true;
        },
        findAllArticles: (state) => {
            state.loading = true;
        },
        findLowStock: (state) => {
            state.loading = true;
        },
        findAllUnites: (state) => {
            state.loading = true;
        },
        activate: (state) => {
            state.loading = true;
        },
        findNatures: (state) => {
            state.loading = true;
        },
        findBySupplier: (state) => {
            state.loading = true;
        },
        addProduct: (state) => {
            state.loading = true;
        },
        updateGlobalStock: (state) => {
            state.loading = true;
        },
        updateProduct: (state) => {
            state.loading = true;
        },
        deleteProduct: (state, action) => {
            state.loading = true;
        },
        checkBarcode: (state, action) => {
            state.loading = true;
        },
        uploadProducts: (state, action) => {
            state.loading = true;
        },
        fetchedData: (state, payload) => {
            state.loading = false;
            state.products = payload.body.content;
            state.totalElements = payload.body.totalElements; // Assuming totalElements is in payload
            state.totalPages = payload.body.totalPages; // Assuming totalPages is in payload
            state.pageNumber = payload.body.pageNumber;
        },
        fetchedPrices: (state, payload) => {
            state.loading = false;
            state.prices = payload.body;
        },
        fetchedUnites: (state, payload) => {
            state.loading = false;
            state.unites = payload;

        },
        finishFetching: (state) => {
            state.loading = false;
        },
        fetchError: (state, action) => {
            console.log(action);
            state.loading = false;
            state.error = action || "An error occurred";
        },
        clearError: (state) => {
            state.error = null;
        },
    },
    sagas: (A) => ({
        *[A.findAllPrices]({ payload }) {
            try {
                const { data } = yield call(productService.findAllPrices, payload.articleId);
                yield put(A.finishFetching());
                yield put(A.fetchedPrices(data));
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.updateGlobalStock]({ payload }) {
            try {
                const { data } = yield call(productService.updateGlobalStock);
                yield put(A.finishFetching());

                if (payload?.onSuccess) {
                    yield call(payload.onSuccess, data);
                }

            } catch (error) {
                yield put(A.finishFetching());
                yield put(A.fetchError(error.response?.data || "Erreur mise à jour stock global"));

                if (payload?.onError) {
                    yield call(payload.onError, error);
                }
            }
        },
        *[A.search]({ payload }) {
            try {
                console.log(payload);
                const { data } = yield call(productService.search, payload);
                yield put(A.finishFetching());
                yield put(A.fetchedData(data));
                if (payload.onSuccess)
                    yield call(payload.onSuccess, data.body.content);
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.activate]({ payload }) {
            try {
                yield call(productService.activate, payload.id);
                yield put(A.finishFetching());
                yield call(payload.onSuccess);
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
                yield call(payload.onError);
            }
        },
        *[A.findPrixAchat]({ payload }) {
            try {
                const { data } = yield call(productService.findPrixAchat, payload.articleId, payload.fournisseurId);
                yield put(A.finishFetching());
                yield call(payload.onSuccess, data.body);
            } catch (error) {
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.findAll]({ payload }) {
            try {
                const data = yield call(productService.findAll, payload.search, payload.page, payload.size);
                yield put(A.finishFetching());
                yield put(A.fetchedData(data));
                if (payload?.onSuccess) {
                    yield call(payload.onSuccess, data);
                }
            } catch (error) {
                yield put(A.finishFetching());
                yield put(A.fetchError());
                if (payload?.onError) {
                    yield call(payload.onError, error);
                }

            }
        },
        *[A.findReception]({ payload }) {
            try {
                const data = yield call(productService.findReception, payload.search, payload.page, payload.size);
                yield put(A.finishFetching());
                yield put(A.fetchedData(data));
                if (payload?.onSuccess) {
                    yield call(payload.onSuccess, data.body?.content || data.content || []);
                }
            } catch (error) {
                yield put(A.finishFetching());
                yield put(A.fetchError());
                if (payload?.onError) {
                    yield call(payload.onError, error);
                }
            }
        },
        *[A.findAllArticles]({ payload }) {
            try {
                const data = yield call(productService.findAllArticles, payload.query, payload.categorieId, payload.page, payload.size);
                yield put(A.finishFetching());
                yield put(A.fetchedData(data));
                if (payload?.onSuccess) {
                    yield call(payload.onSuccess, data);
                }
            } catch (error) {
                yield put(A.finishFetching());
                yield put(A.fetchError());
                if (payload?.onError) {
                    yield call(payload.onError, error);
                }

            }
        },
        *[A.findLowStock]() {
            try {
                const data = yield call(productService.findLowStock);
                yield put(A.finishFetching());
                yield put(A.fetchedData(data));
            } catch (error) {
                yield put(A.finishFetching());
                yield put(A.fetchError());

            }
        },
        *[A.findAllUnites]() {
            try {
                const { data } = yield call(productService.findAllUnites);
                yield put(A.finishFetching());
                yield put(A.fetchedUnites(data));
            } catch (error) {
                yield put(A.finishFetching());
                yield put(A.fetchError());

            }
        },
        *[A.findNatures]() {
            try {
                const { data } = yield call(productService.findNatures);
                yield put(A.finishFetching());
                yield put(A.fetchedNatureData(data));

            } catch (error) {
                yield put(A.finishFetching());
                yield put(A.fetchError());

            }
        },
        *[A.findBySupplier]({ payload }) {
            try {
                const { supplierId, page, size, onSuccess } = payload;
                const data = yield call(productService.findBySupplier, supplierId, page, size);
                yield put(A.finishFetching());
                if (onSuccess) onSuccess(data.body);
            } catch (error) {
                yield put(A.finishFetching());
                yield put(A.fetchError());

            }
        },
        *[A.checkBarcode]({ payload }) {
            try {
                const { onSuccess } = payload;
                const { data } = yield call(productService.checkBarcode, payload.barcode);
                yield put(A.finishFetching());
                if (onSuccess) onSuccess(data.body);
            } catch (error) {
                yield put(A.finishFetching());
                yield put(A.fetchError());
                if (payload?.onError) {
                    yield call(payload.onError, error);
                }

            }
        },
        *[A.addProduct]({ payload }) {
            try {
                const { data } = yield call(productService.save, payload.formData);
                yield put(A.finishFetching());
                if (payload?.onSuccess) {
                    yield call(payload.onSuccess, data);
                }
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError(e.response?.data?.message || e.message));
                if (payload?.onError) {
                    yield call(payload.onError, e);
                }
            }
        },

        *[A.updateProduct]({ payload }) {
            try {
                const { data } = yield call(productService.update, payload.id, payload.formData);
                yield put(A.finishFetching());
                yield call(payload.onSuccess);

            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError(e));
            }
        },
        *[A.deleteProduct]({ payload }) {
            try {
                const { data } = yield call(productService.delete, payload.id);
                yield put(A.finishFetching());
                yield call(payload.onSuccess);
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
                yield call(payload.onError);
            }
        },
        *[A.uploadProducts]({ payload }) {
            try {
                yield call(productService.upload, payload);
                yield put(A.finishFetching());
                yield call(payload.onSuccess);
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.updatePrice]({ payload }) {
            try {
                const { data } = yield call(productService.updatePrice, payload);
                yield put(A.finishFetching());
                yield call(payload.onSuccess, data);

            } catch (error) {
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        }

    }),

});

export default productSlice;
export const productActions = productSlice.actions;
